import { gql, useQuery } from '@apollo/client';
import type {
  GetProvidersPhotosQuery,
  GetProvidersPhotosQueryVariables,
} from '../../__generated__/queries-web';

const GET_PROVIDERS_PHOTOS = gql`
  query GetProvidersPhotos(
    $query: NonEmptyTrimmedString!
    $perPage: UnsignedInt!
    $providers: [ImageProviderName!]!
    $currentPage: UnsignedInt
  ) {
    searchExternalImages(
      query: $query
      perPage: $perPage
      currentPage: $currentPage
      providers: $providers
    ) {
      name
      items {
        id
        medium
        large
        preview {
          height
          url
          width
        }
        small
      }
    }
  }
`;

export const useGetProvidersPhotos = (
  variables: GetProvidersPhotosQueryVariables,
  skip = false,
) =>
  useQuery<GetProvidersPhotosQuery, GetProvidersPhotosQueryVariables>(
    GET_PROVIDERS_PHOTOS,
    {
      notifyOnNetworkStatusChange: true,
      skip,
      variables,
    },
  );
